/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UnAuthorizedPageContent } from '../../models/un-authorized-page-content';

export interface GetUnauthorizedPageContent$Params {
}

export function getUnauthorizedPageContent(http: HttpClient, rootUrl: string, params?: GetUnauthorizedPageContent$Params, context?: HttpContext): Observable<StrictHttpResponse<UnAuthorizedPageContent>> {
  const rb = new RequestBuilder(rootUrl, getUnauthorizedPageContent.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UnAuthorizedPageContent>;
    })
  );
}

/**
 * Custom addition for our mocking infrastructure
 * in case this ever causes problems we can also keep a dictionary that maps operations to paths on the side
 **/
getUnauthorizedPageContent.PATH = '/api/gamaroleconfig/unauthorizedpagecontent';
getUnauthorizedPageContent.METHOD = 'get';

/**
 * we annotate each endpoint with a root rootUrl
 * this is because we have multiple APIs so we need to know which api fn belongs to
 * so we can map it depending on the env. rootUrl is picked from the first server listed in the APISpec
 **/
getUnauthorizedPageContent.ROOTURL = '/portal';
